import PropTypes from 'prop-types';
import React from 'react';

import AnalysisForResearchContent from './AnalysisForResearchContent';
import AppContext from '../../../AppContext';
import Constants from './Constants';
import IceContext from './IceContext';
import IntroModal from './ResearchIntroModal';
import Menu from './Menu';
import SelectSettingContent from './SelectSettingContent';
import SettingContent from './SettingContent';
import SimulationContent from './SimulationContent';
import WagonSettingContent from './WagonSettingContent';
import WeatherContent from './WeatherContent';

export default class IceFieldResearchPage extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.seed = Math.random();

    let firstCtx = new IceContext(this.seed);
    let secondCtx = new IceContext(this.seed, firstCtx.weather, firstCtx.temperature);
    this.state = {
      page: 'wagon-setting',
      iceCtxs: [firstCtx, secondCtx],
      wagon: 0,
      date: 0, // 0: base day, 1: validation day
      changableSetting: -1, // 0: place, 1: ice, 2: price
      price: 300,
      introModal: true,
    };
  }

  componentDidMount() {
    this.context.soundController.bgmPlay('proc_field02', true);

    // If browser reload this page or access to this page directly,
    // The parent dom is NOT rendered and the IntroModal try to refer to it and failed.
    // This code assures that the parent dom is rendered once.
    requestAnimationFrame(() => {
      this.forceUpdate();
    });
  }

  innerView() {
    if (this.state.page === 'wagon-setting') {
      return (
        <WagonSettingContent
          title={this._getTitle()}
          wagon={this.state.wagon}
          research={true}
          onWagonChange={this._onWagonChange.bind(this)}
          onNextClick={this._onNextClick.bind(this)}
        />
      );
    } else if (this.state.page === 'weather' || this.state.page === 'weather-2nd') {
      return (
        <WeatherContent
          research={true}
          iceCtx={this._currentIceCtx()}
          subTitle={Constants.WEEKDAY_LABELS[this._currentIceCtx().weekday]}
          onChange={this.state.page === 'weather' ? this._onWeatherChange.bind(this) : null}
          onNextClick={this._onNextClick.bind(this)}
          onPreviousClick={this.state.page === 'weather' ? this._onPreviousClick.bind(this) : null}
        />
      );
    } else if (this.state.page === 'setting' || this.state.page === 'setting-2nd') {
      return (
        <SettingContent
          research={true}
          changableSetting={this.state.page === 'setting' ? -1 : this.state.changableSetting}
          wagon={this.state.wagon}
          title={this._getTitle()}
          iceCtx={this._currentIceCtx()}
          onNextClick={this._onNextClick.bind(this)}
          onPlaceChange={this._onPlaceChange.bind(this)}
          onIceChange={this._onIceChange.bind(this)}
          onPriceChange={this._onPriceChange.bind(this)}
          onWagonChange={this._onWagonChange.bind(this)}
          onPreviousClick={
            this.state.page === 'setting-2nd' ? this._onPreviousClick.bind(this) : this._onPreviousClick.bind(this)
          }
        />
      );
    } else if (this.state.page === 'select-setting') {
      return (
        <SelectSettingContent
          wagon={this.state.wagon}
          changableSettingChange={this.state.changableSetting}
          iceCtx={this._currentIceCtx()}
          onChangableSettingChange={this._onChanableSettingChange.bind(this)}
          onNextClick={this._onNextClick.bind(this)}
          onPreviousClick={this._onPreviousClick.bind(this)}
        />
      );
    } else if (this.state.page === 'simulation' || this.state.page === 'simulation-2nd') {
      return (
        <SimulationContent
          research={true}
          wagon={this.state.wagon}
          customers={this._currentIceCtx().customers}
          iceCtx={this._currentIceCtx()}
          onPriceChange={this._onPriceChange.bind(this)}
          onNextClick={this._onNextClick.bind(this)}
          onUpdateResults={this._onUpdateResults.bind(this)}
        />
      );
    } else if (this.state.page === 'analysis' || this.state.page === 'analysis-2nd') {
      return (
        <AnalysisForResearchContent
          wagon={this.state.wagon}
          iceCtxs={this.state.iceCtxs}
          compare={this.state.page === 'analysis-2nd'}
          changableSetting={this.state.changableSetting}
          onNextClick={this._onNextClick.bind(this)}
        />
      );
    } else {
      return <span />;
    }
  }

  _getTitle() {
    return `しらべる`;
  }

  render() {
    const showMenu = ['simulation', 'simulation-2nd', 'weather', 'weather-2nd', 'end'].every(
      p => p !== this.state.page
    );

    if (this.state.introModal) {
      return (
        <div id={'proc-ice-fields-root-page'} className={'ice'}>
          <IntroModal title="はじめに" onNextClick={this._onIntroNextClick.bind(this)} />
        </div>
      );
    }

    let menuText = 'しらべる';
    if (
      this.state.page === 'setting' ||
      this.state.page === 'setting-2nd' ||
      this.state.page === 'select-setting' ||
      this.state.page === 'analysis' ||
      this.state.page === 'analysis-2nd'
    ) {
      menuText = Constants.WEEKDAY_LABELS[this._currentIceCtx().weekday];
    }

    return (
      <div id={'proc-ice-fields-root-page'} className={'ice proc-ice-field-page h100 gray10-bg-color'}>
        {showMenu && (
          <Menu
            exitLink={'/ice/fields/'}
            query={'?skip_intro=true'}
            menuText={menuText}
            title={'ワゴンで うりに いこう'}
            subTitle={'しらべる'}
          />
        )}
        {this.innerView()}
      </div>
    );
  }

  _onIntroNextClick() {
    this.setState({ introModal: false });
  }

  _onNextClick(round) {
    if (this.state.page === 'wagon-setting') {
      this.context.soundController.bgmPlay('proc_field02', true);
      this.setState({ page: 'weather' });
    } else if (this.state.page === 'weather') {
      this.context.soundController.bgmPlay('proc_field02', true);
      this.setState({ page: 'setting' });
    } else if (this.state.page === 'setting') {
      this.context.soundController.bgmPlay('proc_field01', true);
      this.setState({ page: 'simulation' });
    } else if (this.state.page === 'simulation') {
      this.context.soundController.bgmPlay('proc_field02', true);
      this.setState({ page: 'analysis' });
    } else if (this.state.page === 'analysis') {
      this.context.soundController.bgmPlay('proc_field02', true);
      this._copySetting(this.state.iceCtxs[0], this.state.iceCtxs[1]);
      this.setState({ date: 1, page: 'weather-2nd' });
    } else if (this.state.page === 'weather-2nd') {
      this.context.soundController.bgmPlay('proc_field02', true);
      this.setState({ changableSetting: 0, page: 'select-setting' });
    } else if (this.state.page === 'select-setting') {
      this.context.soundController.bgmPlay('proc_field02', true);
      this._resetSetting();
      this.setState({ iceCtxs: this.state.iceCtxs, page: 'setting-2nd' });
    } else if (this.state.page === 'setting-2nd') {
      this.context.soundController.bgmPlay('proc_field01', true);
      this.setState({ page: 'simulation-2nd' });
    } else if (this.state.page === 'simulation-2nd') {
      this.context.soundController.bgmPlay('proc_field02', true);
      this.setState({ page: 'analysis-2nd' });
    } else if (this.state.page === 'analysis-2nd') {
      this.context.soundController.bgmPlay('proc_field02', true);
      let iceCtx;
      if (round === 'current') {
        iceCtx = new IceContext(this.seed, this.state.iceCtxs[1].weather, this.state.iceCtxs[1].temperature);
        this._copySetting(this.state.iceCtxs[1], iceCtx);
        this.setState({ date: 1, page: 'weather-2nd', iceCtxs: [this.state.iceCtxs[1], iceCtx] });
      } else {
        iceCtx = new IceContext(this.seed, this.state.iceCtxs[0].weather, this.state.iceCtxs[0].temperature);
        this._copySetting(this.state.iceCtxs[0], iceCtx);
        this.setState({ date: 1, page: 'weather-2nd', iceCtxs: [this.state.iceCtxs[0], iceCtx] });
      }
    }
  }

  _onWeatherChange() {
    let firstCtx = new IceContext(this.seed);
    let secondCtx = new IceContext(this.seed, firstCtx.weather, firstCtx.temperature);
    this.setState({ iceCtxs: [firstCtx, secondCtx] });
  }

  _onPreviousClick() {
    if (this.state.page === 'wagon-setting') {
      this.setState({ page: 'wagon-setting' });
    } else if (this.state.page === 'weather') {
      this.setState({ page: 'wagon-setting' });
    } else if (this.state.page === 'setting') {
      this.setState({ page: 'weather' });
    } else if (this.state.page === 'simulation') {
      this.setState({ page: 'setting' });
    } else if (this.state.page === 'analysis') {
      this.setState({ page: 'simulation' });
    } else if (this.state.page === 'weather-2nd') {
      this.setState({ page: 'analysis' });
    } else if (this.state.page === 'select-setting') {
      this.setState({ page: 'weather-2nd' });
    } else if (this.state.page === 'setting-2nd') {
      this._revertSetting();
      this.setState({ page: 'select-setting' });
    } else if (this.state.page === 'analysis-2nd') {
      this.setState({ page: 'setting-2nd' });
    }
  }

  _copySetting(from, to) {
    to.price = from.price;
    to.place = from.place;
    to.weekday = from.weekday;
    to.ice = from.ice;
  }

  _revertSetting() {
    let iceCtx = this.state.iceCtxs[1];
    if (this.state.changableSetting === 0) {
      iceCtx.place = this.previousSetting;
    } else if (this.state.changableSetting === 1) {
      iceCtx.ice = this.previousSetting;
    } else {
      iceCtx.price = this.previousSetting;
    }
  }

  _resetSetting() {
    let iceCtx = this.state.iceCtxs[1];
    if (this.state.changableSetting === 0) {
      //TODO refactoring. should not use global variables.
      this.previousSetting = iceCtx.place;
      iceCtx.place = -1;
    } else if (this.state.changableSetting === 1) {
      this.previousSetting = iceCtx.ice;
      iceCtx.ice = -1;
    } else {
      this.previousSetting = iceCtx.price;
    }
  }

  _onPlaceChange(place) {
    let iceCtx = this._currentIceCtx();
    iceCtx.place = place;
    this._copyChangeToNext();
    this.setState({ iceCtxs: this.state.iceCtxs });
  }

  _onIceChange(ice) {
    let iceCtx = this._currentIceCtx();
    iceCtx.ice = ice;
    this._copyChangeToNext();
    this.setState({ iceCtxs: this.state.iceCtxs });
  }

  _onPriceChange(price) {
    let iceCtx = this._currentIceCtx();
    iceCtx.price = price;
    this._copyChangeToNext();
    this.setState({ iceCtxs: this.state.iceCtxs });
  }

  _onWagonChange(wagon) {
    this.setState({ wagon });
  }

  _onChanableSettingChange(setting) {
    this.setState({ changableSetting: setting });
  }

  _onUpdateResults(results) {
    let iceCtx = this._currentIceCtx();
    for (const result of results) {
      iceCtx.addSalesData(result.salesData);
      iceCtx.addCustomersData(result.customersData);
      iceCtx.addPurchasersData(result.purchasersData);
      iceCtx.addPriceTransitionData(result.priceTransitionData);
    }
    this.setState({ iceCtxs: this.state.iceCtxs });
  }

  _currentIceCtx() {
    return this.state.iceCtxs[this.state.date];
  }

  _copyChangeToNext() {
    if (this.state.date < 1) {
      let current = this.state.iceCtxs[this.state.date];
      let next = this.state.iceCtxs[this.state.date + 1];
      next.price = current.price;
      next.ice = current.ice;
      next.place = current.place;
    }
  }
}

IceFieldResearchPage.propTypes = {
  results: PropTypes.array,
};

IceFieldResearchPage.defaultProps = {};
